import { fetchAsObservable } from "fetcher!sofe";

export function getSelectUser(user_exchange_id) {

  const body = {
    grant_type: "user_exchange",
    user_exchange_id,
  };

  return fetchAsObservable(`/token`, {
    passThrough401: true,
    method: 'post',
    headers: {
      'Authorization': 'Basic ' + btoa('TaxUI:f7fsf29adsy9fg')
    },
    body,
  })
}

export function postLoginRedirect(redirectUrl) {
  const validRedirectUrls = /^https?:\/\/[\w-]*\.([\w]*\.)?(clientportal|canopy)(\.dev|tax\.com|\.ninja|\.com)/;
  const validLocalUrl = /^http:\/\/127\.0\.0\.1:\d\d\d\d\d?/;
  if (redirectUrl && (redirectUrl.match(validRedirectUrls) || redirectUrl.match(validLocalUrl))) {
    window.location.href = redirectUrl
  } else {
    const { origin, host } = window.location
    const destination = window.responsiveMode ? `https://${host}/m/` : origin
    window.location.href = destination
  }
}
